<template>
  <div id="app">
    <component :is="layout">
      <router-view></router-view>
    </component>
  </div>
</template>
<script>
  const default_layout = "default";

  export default {
    components: {
    },
    computed: {
      layout() {
        return (this.$route.meta.layout || default_layout) + '-layout';
      }
    }
  }
</script>
<style>
  @import "./assets/style.less";

  .layout {
    border: 1px solid #d7dde4;
    background: #f5f7f9;
  }

  .layout-nav {
    width: 420px;
    margin: 0 auto;
  }

  .layout-content {
    min-height: 800px;
    margin: 15px;
    overflow: hidden;
    background: #fff;
    border-radius: 4px;
  }

  .layout-content-main {
    padding: 10px;
  }

  .layout-copy {
    text-align: center;
    padding: 10px 0 20px;
    color: #9ea7b4;
  }

  .layout-user {
    float: right !important;
  }

  .layout-icon {
    /*margin-right: 200px;*/
  }

  .layout-ceiling-main a {
    color: #9ba7b5;
  }
  .layout-menu-style {
    width: auto !important;
  }
</style>



// WEBPACK FOOTER //
// app.vue?370f0dff